export const removeVietnameseTones = (str) => {
  return str
    .normalize("NFD") // chuyển về dạng phân tách ký tự
    .replace(/[\u0300-\u036f]/g, "") // xóa các dấu
    .replace(/đ/g, "d") // đ -> d
    .replace(/Đ/g, "D") // Đ -> D
    .toLowerCase();
};
